import * as React from 'react';
import * as style from './SalesLeader.css';
import { SalesLeaderIcon } from '../../../SalesLeaderIcon';
import { TooltipLink } from '../../../TooltipLink';

interface ISalesLeaderProps {
  salesLeaderUrl?: string | null;
}

export const SalesLeader: React.FC<ISalesLeaderProps> = props => {
  const { salesLeaderUrl } = props;

  return (
    <TooltipLink
      className={style['salesLeaderTooltipLink']}
      url={salesLeaderUrl}
      width={123}
      text="Лидер продаж ↗"
      target="blank"
    >
      <SalesLeaderIcon />
    </TooltipLink>
  );
};
